/* eslint-disable @typescript-eslint/no-explicit-any */
import { once as _once } from 'es-toolkit/compat';
import { useCallback } from 'react';

export function useOnce(fn: any) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onceFunction = useCallback(_once(fn), [fn]);

  return onceFunction;
}
